import type { JwtTokenPayload } from 'shared/jwt'

import { decodeJwt } from './decode-jwt'
import { getJwtToken } from './get-jwt-token'

export const extractTokenPayload = () => {
  const token = getJwtToken()

  if (!token) return null

  return decodeJwt<JwtTokenPayload>(token)
}
